/**
 * Day-to-day screens (appointments, checkout, cash, customers, services, my day, platform).
 * One row per key: [key, English, 中文, Bahasa Melayu] — a row can't miss a language.
 */
const ROWS = [
  ["appt.booked", "{n} booked", "已预约 {n} 个", "{n} ditempah"],
  ["appt.prevDay", "Previous day", "前一天", "Hari sebelumnya"],
  ["appt.nextDay", "Next day", "后一天", "Hari berikutnya"],
  ["appt.pickDate", "Pick a date", "选择日期", "Pilih tarikh"],
  ["appt.new", "New booking", "新建预约", "Tempahan baharu"],
  ["appt.closedDay", "The location is closed on this day", "该门店当天休息", "Lokasi ini tutup pada hari ini"],
  ["appt.noStaff", "No one takes appointments here yet", "暂无可接受预约的成员", "Belum ada sesiapa menerima temujanji di sini"],
  ["appt.noStaff.sub", "Turn on “Takes appointments” for team members in Team.", "请在“团队”中为成员开启“接受预约”。", "Hidupkan “Menerima temujanji” untuk ahli dalam Pasukan."],
  ["appt.bookAt", "Book {name} at {time}", "预约 {name} {time}", "Tempah {name} pada {time}"],
  ["appt.checkIn", "Check in", "到店签到", "Daftar masuk"],
  ["appt.startService", "Start service", "开始服务", "Mula perkhidmatan"],
  ["appt.recordDeposit", "Record deposit", "记录定金", "Rekod deposit"],
  ["appt.checkout", "Checkout", "结账", "Bayar"],
  ["appt.cancel", "Cancel booking", "取消预约", "Batal tempahan"],
  ["appt.move", "Move", "改期", "Pindah"],
  ["appt.holdNote", "Slot held until {time} for a {amount} deposit. It's released automatically if unpaid.", "时段保留至 {time}，待支付定金 {amount}。未付款将自动释放。", "Slot ditahan sehingga {time} untuk deposit {amount}. Ia dilepaskan secara automatik jika tidak dibayar."],
  ["appt.totalEst", "Total (est.)", "合计（预估）", "Jumlah (anggaran)"],
  ["appt.depositPaid", "Deposit paid", "已付定金", "Deposit dibayar"],
  ["appt.confirmNoDeposit", "Confirm without deposit", "无需定金直接确认", "Sahkan tanpa deposit"],
  ["appt.cancelQ", "Cancel this booking?", "取消此预约？", "Batalkan tempahan ini?"],
  ["appt.noShowQ", "Mark as no-show?", "标记为爽约？", "Tandakan sebagai tidak hadir?"],
  ["appt.depositStays", "The deposit stays recorded; refunds are handled separately.", "定金记录会保留，退款另行处理。", "Deposit kekal direkodkan; bayaran balik diuruskan berasingan."],
  ["appt.timeFrees", "The time becomes available again.", "该时段将重新开放。", "Masa itu akan tersedia semula."],
  ["appt.markNoShow", "Mark no-show", "标记爽约", "Tanda tidak hadir"],
  ["appt.deposit", "Deposit", "定金", "Deposit"],
  ["appt.moveTo", "Move to", "改到", "Pindah ke"],
  ["appt.noTimesWith", "No free times with {name} on this day.", "{name} 当天没有空闲时段。", "Tiada masa lapang dengan {name} pada hari ini."],
  ["appt.moveQ", "Move this booking?", "改期此预约？", "Pindahkan tempahan ini?"],
  ["appt.moveConfirm", "Move booking", "确认改期", "Pindah tempahan"],
  ["appt.moveBody", "{customer} with {staff} → {time} on {date}.", "{customer}（{staff}）→ {date} {time}。", "{customer} dengan {staff} → {time} pada {date}."],
  ["appt.booking", "Booking…", "预约中…", "Menempah…"],
  ["appt.bookTime", "Book {time}", "预约 {time}", "Tempah {time}"],
  ["appt.book", "Book", "预约", "Tempah"],
  ["appt.change", "Change", "更换", "Tukar"],
  ["appt.teamMember", "{staff}", "{staff}", "{staff}"],
  ["appt.anyone", "Anyone available", "任意空闲人员", "Sesiapa yang ada"],
  ["appt.noTimes", "No free times on this day.", "当天没有空闲时段。", "Tiada masa lapang pada hari ini."],
  ["appt.collectDeposit", "Collect deposit now (holds the slot for a few minutes)", "现在收取定金（时段将保留几分钟）", "Kutip deposit sekarang (slot ditahan beberapa minit)"],
  ["appt.collectDeposit.sub", "Turn off to confirm without a deposit.", "关闭则无需定金直接确认。", "Matikan untuk mengesahkan tanpa deposit."],
  ["pay.method.cash", "Cash", "现金", "Tunai"],
  ["pay.method.external_card", "Card terminal", "刷卡机", "Terminal kad"],
  ["pay.method.bank_transfer", "Bank transfer", "银行转账", "Pindahan bank"],
  ["pay.method.stripe", "Online card", "线上银行卡", "Kad dalam talian"],
  ["pay.amount", "Amount", "金额", "Amaun"],
  ["pay.ref.bank_transfer", "Transfer reference", "转账参考号", "Rujukan pindahan"],
  ["pay.ref.external_card", "Terminal approval code", "刷卡授权码", "Kod kelulusan terminal"],
  ["pay.manualNote", "Recorded by staff (not verified by a payment provider).", "由员工手动记录（未经支付机构验证）。", "Direkod oleh staf (tidak disahkan oleh penyedia pembayaran)."],
  ["pay.record", "Record {amount}", "记录 {amount}", "Rekod {amount}"],
  ["pay.changeDue", "Change due:", "应找零：", "Baki untuk dipulangkan:"],
  ["pay.backToSale", "Back to sale", "返回订单", "Kembali ke jualan"],
  ["pay.balanceDue", "Balance due", "待付余额", "Baki perlu dibayar"],
  ["pay.orderTotal", "Order total", "订单总额", "Jumlah pesanan"],
  ["pay.splitHint", "Split payments: take part now, then choose another method for the rest.", "分开付款：先收部分金额，剩余部分再选择其他方式。", "Bayaran berpecah: ambil sebahagian sekarang, kemudian pilih kaedah lain untuk bakinya."],
  ["pay.connectFirst", "Connect Stripe first", "请先连接 Stripe", "Sambung Stripe dahulu"],
  ["pay.recordedManually", "Recorded manually", "手动记录", "Direkod secara manual"],
  ["pay.cashReceived", "Cash received", "实收现金", "Tunai diterima"],
  ["pay.change", "Change", "找零", "Baki"],
  ["pay.recording", "Recording…", "记录中…", "Merekod…"],
  ["pay.take", "Take {amount}", "收款 {amount}", "Terima {amount}"],
  ["pos.customer", "Customer", "顾客", "Pelanggan"],
  ["pos.held", "Held sales", "挂单", "Jualan ditangguh"],
  ["pos.newSale", "New sale", "新建销售", "Jualan baharu"],
  ["pos.all", "All", "全部", "Semua"],
  ["pos.noServices", "Nothing to sell yet", "暂无可销售项目", "Belum ada apa-apa untuk dijual"],
  ["pos.noServices.sub", "Add services in Services to see them here.", "请在“服务项目”中添加后即可在此显示。", "Tambah perkhidmatan dalam Perkhidmatan untuk memaparkannya di sini."],
  ["pos.retail", "Retail", "零售", "Runcit"],
  ["pos.currentSale", "Current sale", "当前订单", "Jualan semasa"],
  ["pos.addCustomer", "Add customer", "添加顾客", "Tambah pelanggan"],
  ["pos.tapToStart", "Tap a service or product to start.", "点击服务或产品开始。", "Ketik perkhidmatan atau produk untuk bermula."],
  ["pos.editLine", "Edit {name}", "编辑 {name}", "Sunting {name}"],
  ["pos.priceSet", "price set", "已改价", "harga ditetapkan"],
  ["pos.staffFor", "{staff} for {name}", "{name} 的{staff}", "{staff} untuk {name}"],
  ["pos.assignStaff", "Choose {staffLower}", "选择{staffLower}", "Pilih {staffLower}"],
  ["pos.subtotal", "Subtotal", "小计", "Subjumlah"],
  ["pos.depositReceived", "Deposit received", "已收定金", "Deposit diterima"],
  ["pos.due", "Due", "应付", "Perlu dibayar"],
  ["pos.discount", "Discount", "折扣", "Diskaun"],
  ["pos.hold", "Hold sale", "挂单", "Tangguh jualan"],
  ["pos.resume", "Resume sale", "继续订单", "Sambung jualan"],
  ["pos.qty", "Quantity", "数量", "Kuantiti"],
  ["pos.less", "Less", "减少", "Kurang"],
  ["pos.more", "More", "增加", "Lagi"],
  ["pos.unitPrice", "Unit price (list {list})", "单价（标价 {list}）", "Harga seunit (senarai {list})"],
  ["pos.priceHint", "Lowering a price needs a manager. “From” prices can be raised.", "降价需要店长授权，“起价”项目可以加价。", "Menurunkan harga memerlukan pengurus. Harga “dari” boleh dinaikkan."],
  ["pos.lineDiscount", "Line discount", "单项折扣", "Diskaun item"],
  ["pos.percent", "Percent", "百分比", "Peratus"],
  ["pos.amountOff", "Amount off", "减免金额", "Amaun potongan"],
  ["pos.lineMore", "Variants, open pricing and splitting credit between staff are coming in the next update.", "规格、自定价格和多人业绩拆分将在下次更新中推出。", "Varian, harga terbuka dan pembahagian kredit antara staf akan tiba dalam kemas kini seterusnya."],
  ["pos.discountDefault", "Member discount", "会员折扣", "Diskaun ahli"],
  ["pos.apply", "Apply", "应用", "Guna"],
  ["pos.percentOff", "Percent off", "折扣百分比", "Peratus potongan"],
  ["pos.reason", "Reason", "原因", "Sebab"],
  ["pos.largeDiscount", "Large discounts need a manager.", "大额折扣需要店长授权。", "Diskaun besar memerlukan pengurus."],
  ["pos.noHeld", "No sales on hold.", "没有挂单。", "Tiada jualan ditangguh."],
  ["pos.walkIn", "Walk-in", "散客", "Pelanggan tanpa temujanji"],
  ["pos.charge", "Charge {amount}", "收款 {amount}", "Caj {amount}"],
  ["cash.close", "Close drawer", "关闭钱箱", "Tutup laci"],
  ["cash.closedBody", "The drawer is closed. Count the starting cash and open it to take cash payments.", "钱箱已关闭。请清点备用金后开启，以便收取现金。", "Laci ditutup. Kira tunai permulaan dan bukanya untuk menerima bayaran tunai."],
  ["cash.float", "Opening float", "备用金", "Apungan permulaan"],
  ["cash.open", "Open drawer", "开启钱箱", "Buka laci"],
  ["cash.openSince", "Open since {time}", "{time} 起开启", "Dibuka sejak {time}"],
  ["cash.by", "by {name}", "由 {name}", "oleh {name}"],
  ["cash.expected", "Expected in drawer", "钱箱应有金额", "Dijangka dalam laci"],
  ["cash.sales", "Cash sales ({n})", "现金销售（{n}）", "Jualan tunai ({n})"],
  ["cash.in", "Cash in", "存入现金", "Tunai masuk"],
  ["cash.out", "Cash out", "取出现金", "Tunai keluar"],
  ["cash.recent", "Recent closes", "最近结算", "Penutupan terkini"],
  ["cash.expectedShort", "Expected", "应有", "Dijangka"],
  ["cash.counted", "Counted", "实点", "Dikira"],
  ["cash.difference", "Difference", "差额", "Perbezaan"],
  ["cash.outPh", "e.g. petty cash — towels", "例如：零用金——毛巾", "cth. wang runcit — tuala"],
  ["cash.inPh", "e.g. change top-up", "例如：补充零钱", "cth. tambah duit kecil"],
  ["cash.countBody", "Count the cash in the drawer. Expected:", "请清点钱箱现金。应有：", "Kira tunai dalam laci. Dijangka:"],
  ["cash.countedCash", "Counted cash", "实点现金", "Tunai dikira"],
  ["cash.short", "Short by {amount}", "短缺 {amount}", "Kurang {amount}"],
  ["cash.over", "Over by {amount}", "多出 {amount}", "Lebih {amount}"],
  ["cash.noteRequired", "Note (required)", "备注（必填）", "Nota (wajib)"],
  ["cash.closeQ", "Close the drawer?", "关闭钱箱？", "Tutup laci?"],
  ["cash.closeBody", "Counted {counted} · difference {diff}. Cash payments need a new session afterwards.", "实点 {counted} · 差额 {diff}。之后收取现金需重新开启钱箱。", "Dikira {counted} · perbezaan {diff}. Bayaran tunai memerlukan sesi baharu selepas ini."],
  ["cust.searchPh", "Phone or name", "电话或姓名", "Telefon atau nama"],
  ["cust.new", "New customer", "新建顾客", "Pelanggan baharu"],
  ["cust.noMatch", "No customers match.", "没有匹配的顾客。", "Tiada pelanggan sepadan."],
  ["cust.searchLong", "Search by phone (any format) or name", "按电话（任意格式）或姓名搜索", "Cari ikut telefon (apa-apa format) atau nama"],
  ["cust.empty", "No customers yet", "还没有顾客", "Belum ada pelanggan"],
  ["cust.empty.sub", "Customers are added when you book or check out — or add one now.", "预约或结账时会自动添加顾客，也可以现在手动添加。", "Pelanggan ditambah semasa menempah atau membayar — atau tambah sekarang."],
  ["cust.tab.overview", "Overview", "概览", "Gambaran"],
  ["cust.tab.visits", "Visits", "到店记录", "Lawatan"],
  ["cust.tab.credit", "Wallet", "钱包", "Dompet"],
  ["cust.tab.packages", "Packages", "套餐", "Pakej"],
  ["cust.tab.notes", "Notes", "备注", "Nota"],
  ["cust.visits", "Completed visits", "已完成到店", "Lawatan selesai"],
  ["cust.spent", "Total spent", "累计消费", "Jumlah perbelanjaan"],
  ["cust.since", "Customer since", "成为顾客", "Pelanggan sejak"],
  ["cust.noVisits", "No visits yet", "暂无到店记录", "Belum ada lawatan"],
  ["cust.purchases", "Purchases", "消费记录", "Pembelian"],
  ["cust.credit.empty", "No stored credit", "暂无储值", "Tiada kredit tersimpan"],
  ["cust.packages.empty", "No packages", "暂无套餐", "Tiada pakej"],
  ["cust.comingSoon", "Stored value and packages arrive in the next update.", "储值和套餐将在下次更新中推出。", "Nilai tersimpan dan pakej akan tiba dalam kemas kini seterusnya."],
  ["cust.noNotes", "No notes", "暂无备注", "Tiada nota"],
  ["cust.edit", "Edit customer", "编辑顾客", "Sunting pelanggan"],
  ["cust.phonePh", "e.g. 012-345 6789 or +65…", "例如：012-345 6789 或 +65…", "cth. 012-345 6789 atau +65…"],
  ["svc.sub", "Price changes apply to new bookings and sales; past orders keep their price.", "价格变更只影响新的预约和销售，历史订单保持原价。", "Perubahan harga terpakai untuk tempahan dan jualan baharu; pesanan lama kekal."],
  ["svc.new", "New item", "新建项目", "Item baharu"],
  ["svc.empty", "No services yet", "还没有服务项目", "Belum ada perkhidmatan"],
  ["svc.empty.sub", "Add what you offer with its duration and price.", "添加您提供的服务及其时长和价格。", "Tambah apa yang anda tawarkan dengan tempoh dan harganya."],
  ["svc.category", "Category", "分类", "Kategori"],
  ["svc.duration", "Duration", "时长", "Tempoh"],
  ["svc.priceHere", "Price here", "本店价格", "Harga di sini"],
  ["svc.inactive", "Inactive", "已停用", "Tidak aktif"],
  ["svc.notOffered", "Not offered", "未提供", "Tidak ditawarkan"],
  ["svc.online", "Online", "线上", "Dalam talian"],
  ["svc.newService", "New service", "新建服务", "Perkhidmatan baharu"],
  ["svc.newRetail", "New retail item", "新建零售商品", "Item runcit baharu"],
  ["svc.durationMin", "Duration (min)", "时长（分钟）", "Tempoh (min)"],
  ["svc.cleanup", "Cleanup after (min)", "服务后整理（分钟）", "Kemas selepas (min)"],
  ["svc.fromPrice", "“From” price", "“起价”", "Harga “dari”"],
  ["svc.fromPrice.sub", "final price set at checkout", "最终价格在结账时确定", "harga akhir ditetapkan semasa bayaran"],
  ["svc.showOnline", "Show in online booking", "在线上预约中显示", "Papar dalam tempahan dalam talian"],
  ["svc.fixed", "Fixed", "固定金额", "Tetap"],
  ["svc.depositAmount", "Deposit amount", "定金金额", "Amaun deposit"],
  ["svc.depositPct", "Deposit %", "定金比例 %", "Deposit %"],
  ["svc.whoCan", "Who can do it", "可服务人员", "Siapa boleh melakukannya"],
  ["svc.anyone", "Nobody selected = any team member.", "未选择 = 任何成员均可。", "Tiada dipilih = mana-mana ahli pasukan."],
  ["svc.hide", "Hide options", "收起选项", "Sembunyi pilihan"],
  ["svc.more", "More options — locations, location prices, resource", "更多选项——门店、门店价格、资源", "Lagi pilihan — lokasi, harga lokasi, sumber"],
  ["svc.branchPrice", "Location price (blank = same)", "门店价格（留空 = 相同）", "Harga lokasi (kosong = sama)"],
  ["svc.needs", "Needs a", "需要", "Memerlukan"],
  ["svc.noResource", "No resource", "无需资源", "Tiada sumber"],
  ["svc.chair", "Chair", "座椅", "Kerusi"],
  ["svc.room", "Treatment room", "护理室", "Bilik rawatan"],
  ["svc.modifiers", "Price modifiers", "价格调整项", "Pengubah harga"],
  ["svc.auto", "auto", "自动", "auto"],
  ["emp.title", "My day", "我的今天", "Hari saya"],
  ["emp.none", "No appointments today", "今天没有预约", "Tiada temujanji hari ini"],
  ["emp.none.sub", "New bookings for you will show up here.", "新的预约会显示在这里。", "Tempahan baharu untuk anda akan dipaparkan di sini."],
  ["platform.title", "Salons", "店铺", "Salun"],
  ["platform.subtitle", "All salons on the platform", "平台上的所有店铺", "Semua salun di platform"],
  ["platform.col.salon", "Salon", "店铺", "Salun"],
  ["platform.col.plan", "Plan", "套餐", "Pelan"],
  ["platform.col.status", "Status", "状态", "Status"],
  ["platform.col.branches", "Locations", "门店", "Lokasi"],
  ["platform.col.members", "Members", "成员", "Ahli"],
  ["platform.col.addons", "Add-ons", "加购", "Tambahan"],
] as const;

type Key = (typeof ROWS)[number][0];
const col = (i: 1 | 2 | 3) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<Key, string>;

export const ops = { en: col(1), zh: col(2), ms: col(3) };
